<template>

<app-content-body :is-grid="true">

    <app-card v-on:click="$emit('select', room)" v-for="room in rooms" v-tooltip="'Click to select room'" imageIcon="spaces" :key="room.id" :image="room.image" :title="room.name" :text="room.description" :tags="tags(room)" :no-actions="true" />

</app-content-body>

</template>

<script>

export default {

	props: ['rooms'],

    methods: {
    
        tags: function(room) {

            var tags = []

            if (room.spaces) tags.push({
                theme: 'blue',
                text: 'Limited schedule'
            })

            if (!room.spaces) tags.push({
                theme: 'blue',
                text: 'Open schedule'
            })

            if (room.approval) tags.push({
                theme: 'red',
                text: 'Requires approval'
            })

            return tags
        
        }
    
    }

}

</script>

<style scoped>

</style>